// extracted by mini-css-extract-plugin
module.exports = {"menu":"PopupFilterButton_menu__3Qq2h","arrow":"PopupFilterButton_arrow__3X9uL"};